<template>
  <section v-if="$role.restricAccess($route.name, 'view')">
    <breadcrumb-template
      :headtitle="$route.meta.title"
      :breadcrumbcurrent="$route.meta.title"
    ></breadcrumb-template>
    <v-card class="card-outline force-remove-box">
      <v-card-text class="force-custom-bg">
        <v-container fluid>
          <!-- <v-row
            dense
            no-gutters
            class="mb-5 text-center text-md-left subtitle-1"
          >
            <v-col cols="12" lg="3">
              Total winning share:
              <v-avatar :size="$gold_coin_sm"
                ><img :src="$goldCoinWhite" alt="coin"
              /></v-avatar>
              <strong>{{ totalWinningShares | toNumberWithDecimal }}</strong>
            </v-col>
          </v-row> -->
          <v-row dense class="d-flex justify-end mt-n2">
            <v-col cols="12" lg="2" class="span-label">
              <span>Draw</span>
              <v-combobox
                class="regular-field"
                dense
                clearable
                :items="drawlist"
                item-value="id"
                item-text="name"
                label="Draw"
                v-model="filter.draw"
                
              >
                <!-- <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index === 0" small>
                    <span>{{ item.name }}</span>
                  </v-chip>
                  <span v-if="index === 1" class="grey--text text-caption"
                    >(+{{ filter.draw.length - 1 }})</span
                  >
                </template> -->
              </v-combobox>
            </v-col>

            <v-col cols="12" lg="2" class="span-label">
              <span class="control-label">Dates</span>
              <v-dialog
                ref="dialog"
                v-model="filter_datedialog"
                :return-value.sync="filter.daterange"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    class="regular-field"
                    hide-details
                    dense
                    v-model="filter.daterange"
                    label="Dates"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    clearable
                  ></v-text-field>
                </template>
                <v-date-picker v-model="filter.daterange" scrollable range>
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="red_button"
                    @click="filter_datedialog = false"
                    >Cancel</v-btn
                  >
                  <v-btn
                    text
                    color="green_button"
                    @click="$refs.dialog.save(filter.daterange)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-dialog>
            </v-col>
<!-- 
            <v-col cols="12" lg="3" class="span-label">
              <span>Search any keyword</span>
              <v-text-field
                clearable
                class="regular-field"
                single-line
                v-model="filter.search"
                label="Search"
                hide-details
              ></v-text-field>
            </v-col> -->

            <v-col cols="12" lg="2" class="mt-7" style="padding-top:5px;">
              <v-btn
                color="green_button"
                class="float-right btn-block"
                @click="getDataFromApi()"
                >Search</v-btn
              >
            </v-col>

            <v-col cols="12" class="mt-2">
              <!-- <v-data-table class="custom-header-color table-bordered table-striped" :headers="dt_headers" :items="dt_resultlist" item-key="id" :loading="dt_loading"  :options.sync="dt_options" :server-items-length="dt_totalResult"> -->
              <!-- <template v-slot:[`item.trends`]="{ item }">
                                        {{ (item.trends.length > 0) ? item.trends:0 }}
                                </template>
                                <template v-slot:[`item.resultlist`]="{ item }">
                                        {{ (item.resultlist.length > 0) ? item.resultlist:0 }}
                                        
                                </template> -->

              <!-- </v-data-table> -->

              <v-simple-table
                class="custom-header-color table-bordered table-striped"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Draw</th>
                      <th class="text-left">Area</th>
                      <th class="text-left">Draw trend (combi | accumulated payouts)</th>
                      <th class="text-left">Result</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in dt_resultlist" :key="item.name">
                      <td style="width:200px">{{ item.name }}</td>
                      <td style="width:200px">{{ item.zone_name }}</td>
                      <td v-if="item.trends.length != 0">
                        <div v-if="item.trends.length > 20">
                          <v-row class="p-2">
                            <v-col cols="4" v-for="list in item.trends"
                          :key="list.combination">
                               {{ list["combination"] }}
                            <v-avatar :size="$gold_coin_sm"
                              ><img :src="$goldCoinWhite" alt="coin"
                            /></v-avatar>
                            {{ list["total"] | toNumberWithDecimal }}
                            </v-col>
                          </v-row>
                        </div>
                        <div v-else>
                          <v-row class="p-2">
                            <v-col cols="12" v-for="list in item.trends"
                          :key="list.combination">
                               {{ list["combination"] }}
                            <v-avatar :size="$gold_coin_sm"
                              ><img :src="$goldCoinWhite" alt="coin"
                            /></v-avatar>
                            {{ list["total"] | toNumberWithDecimal }}
                            </v-col>
                          </v-row>
                        </div>
                        <!-- <ul
                          style="margin:10px;list-style:none;margin-left:-10px"
                          v-for="list in item.trends"
                          :key="list.combination"
                        >
                          <li>
                            {{ list["combination"] }}
                            <v-avatar :size="$gold_coin_sm"
                              ><img :src="$goldCoinWhite" alt="coin"
                            /></v-avatar>
                            {{ list["total"] | toNumberWithDecimal }}
                          </li>
                        </ul> -->

                      </td>
                      <td v-else>N/A</td>
                      <td v-if="item.resultlist.length != 0" style="width:200px">
                        <ul
                          style="margin:10px;list-style:none;margin-left:-10px"
                          v-for="result in item.resultlist"
                          :key="result.combinations"
                        >
                          <li>
                            {{ result["combinations"] }}
                          </li>
                        </ul>
                      </td>
                      <td v-else>N/A</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
export default {
  data() {
    return {
      dialogForm: false,
      isLoadingBtn: false,
      isLoadingBtnDelete: false,
      formerror: {},
      modalUpdate: false,
      dt_headers: [
        // { text: 'ID', value: 'id', name: 'id', sortable: true, searchable: false, align: ' d-none'},
        {
          text: "Draw",
          value: "name",
          name: "name",
          sortable: false,
          searchable: true,
        },
        {
          text: "Area",
          value: "zone_name",
          name: "zone_name",
          sortable: false,
          searchable: true,
        },
        // { text: 'Parent agent', value: 'parent_name', name: 'parent_name', sortable: false, searchable: false},
        {
          text: "Draw trend",
          value: "trends",
          name: "trends",
          sortable: false,
          searchable: true,
        },
        {
          text: "Result",
          value: "resultlist",
          name: "resultlist",
          sortable: false,
          searchable: false,
        },
        // { text: 'Previous week', value: 'previous_week', name: 'previous_week', sortable: false, searchable: false},
        // { text: 'Current week', value: 'current_week', name: 'current_week', sortable: false, searchable: false},
        // { text: 'Daily', value: 'daily', name: 'daily', sortable: false, searchable: false},
      ],
      dt_options: {},
      dt_columns: {},
      dt_totalResult: 0,
      dt_searchInput: "",
      dt_searchQuery: "",
      dt_searchAgent: "",
      dt_resultlist: [],
      dt_loading: true,
      dt_itemsPerPage: 50,
      dt_reload: "",

      totalWinningShares: 0,
      previousWeek: 0,
      currentWeek: 0,
      daily: 0,

      form: new this.$Form({
        id: "",
        name: "",
        username: "",
        email: "",
        password: "",
        roles: {},
        user_status: 1,
      }),

      filter: new this.$Form({
        // date: this.$moment().format("YYYY-MM-DD"),
        start_at: null,
        end_at: null,
        draw: [],
        daterange: null,
        status: null,
        search: null,
      }),
      filter_datedialog: null,
      drawlist: [],
    };
  },
  methods: {
    async getDataFromApi() {
      var from,
        to = "";

      if (this.filter.daterange) {
        this.filter.start_at = this.$moment(this.filter.daterange[0]).format(
          "YYYY-MM-DD"
        );
        this.filter.end_at = this.$moment(this.filter.daterange[1]).format(
          "YYYY-MM-DD"
        );
      }
      this.filter
        .post(this.$_CONFIG.api() + "/trendingnumbersdaily")
        .then((res) => {
          this.dt_resultlist = res.data.data;
          console.log(this.dt_resultlist);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getdrawlist() {
      this.$axios
        .get(this.$_CONFIG.api("API_DRAW_DROPDOWN"))
        .then((res) => {
          this.drawlist = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  created() {
    this.getdrawlist();
    this.getDataFromApi();
  },
  mounted() {
    // console.log(this.$moment().format("YYYY-MM-DD"))
  },
};
</script>
<style scoped></style>